angular.module('reporting.dashboards')
    .value('userActionList', {
    ADD_WIDGET: 'addWidget',
    CHANGE_DATA_SOURCE: 'viewresults.sourceConfiguration.configChanged',
    CHANGE_FILTER: 'reporting.filters.filterChanged',
    CHANGE_WIDGET_SETTINGS: 'widgetSettingsChanged',
    COPY_REPORT: 'copyReport',
    CREATE_CUSTOM_PAGE: 'createCustomPage',
    CREATE_REPORT: 'createReport',
    EDIT_REPORT: 'editReport',
    EXPORT_CSV: 'exportCsv',
    EXPORT_IMAGE: 'exportImage',
    EXPORT_PAGE: 'exportPage',
    EXPORT_PDF: 'exportPdf',
    EXPORT_PPTX: 'exportPptx',
    EXPORT_REPORT: 'exportReport',
    EXPORT_WIDGET: 'exportWidget',
    EXPORT_WORD: 'wordExport',
    HIDE_ALL_PAGES: 'hideAllPages',
    HIDE_PAGE: 'hidePage',
    SWITCH_WIDGET_TYPE: 'changedWidget'
});
/**** NOTES:

    Explanation:
        CHANGE_DATA_SOURCE
            Data Source
            Select Metric
            Breakout By
            Group Date By
        SWITCH_WIDGET_TYPE
            Any time widget type changes. Sometimes happens when DS changed.
        CHANGE_WIDGET_SETTINGS
            Anything on the the right sidebar

    THE FOLLOWING EVENTS OVERLAP:

        EXPORT_PAGE
        EXPORT_REPORT
            with
        EXPORT_WORD
        EXPORT_CSV
        EXPORT_PDF

        EXPORT_WIDGET
            with
        EXPORT_IMAGE
        EXPORT_CSV

        CHANGE_WIDGET_SETTINGS
            with
        CHANGE_DATA_SOURCE
        SWITCH_WIDGET_TYPE

*/
